window.Products.Clothing.Shorts = function() {
};
window.Products.Clothing.Shorts.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.Shorts.id = 47;
window.Products.Clothing.Shorts.slug = 'shorts';
window.Products.Clothing.Shorts.has_3d = true;
window.Products.Clothing.Shorts.dpi = 150;

window.Products.Clothing.Shorts.prototype.set3dProperties = function(modelViewer) {
    this.updateThreeTexture(modelViewer);
    modelViewer.object.position.y = -1.60;
    modelViewer.camera.position.z =  1.7;
    modelViewer.initalCameraPosition.z = -1.7;
};

window.Products.Clothing.Shorts.prototype.setThreeControls = function(controls) {
    controls.minDistance = 1.3;
    controls.maxDistance = 1.7;
};

window.Products.Clothing.Shorts.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material[0].map = modelViewer.texture;
    modelViewer.object.children[0].material[1].map = modelViewer.texture;
};